import {useFoodForms} from "@client/features/foods";
import * as search from "@client/features/search";
import * as forms from "@client/forms";
import * as router from "@client/router";
import * as analytics from "@client/shared/analytics";
import {server} from "@reactivated";
import React from "react";

export const CreateFood = router.CreateFood.withHooks(() => {
    return useFoodForms({initial: null});
})
    .withTab(
        {
            name: "macros",
            icon: "bullseye",
            title: "Macros",
            hasErrors: (props) => props.basicLayout.hasErrors,
        },
        (props) => <>{props.basicLayout.component}</>,
    )
    .withTab(
        {
            name: "advanced",
            icon: "list",
            title: "Advanced",
            hasErrors: (props) => props.advancedLayout.hasErrors,
        },
        (props) => <>{props.advancedLayout.component}</>,
    )
    .withActions((props) => [
        props.form.values.name.toLowerCase() === "sentry throw exception"
            ? {
                  icon: "0442-power" as const,
                  title: "Throw Exception",
                  onClick: () => {
                      throw new Error("Throwing an exception.");
                  },
              }
            : null,
        props.form.values.name.toLowerCase() === "sentry undefined function"
            ? {
                  icon: "0442-power" as const,
                  title: "Undefined Function",
                  onClick: () => {
                      const invalidAccess = {};
                      // @ts-expect-error Intentional for Sentry testing
                      alert(invalidAccess.deeplyNested()); // oxlint-disable-line
                  },
              }
            : null,
        {
            icon: "save",
            title: "Save",
            onClick: async () => {
                const response = await forms.submitForm(
                    props.form,
                    server.journal.nutrition.create_food,
                );
                if (response?.type === "success") {
                    void props.dispatch(search.loadSearch({reset: true}));
                    props.notify("Your food was created");
                    void router.push("food_list.index", {});
                    void analytics.track("CREATED_FOOD");
                }
            },
        },
    ])
    .withOptions(() => ({
        title: "Create Food",
        // In case we arrive from corrections or missing UPC.
        back: "My Foods",
        scene: {kind: "SIMPLE"},
    }));
